import { render, staticRenderFns } from "./CompanyHeader.vue?vue&type=template&id=621a6d0f&scoped=true&"
import script from "./CompanyHeader.vue?vue&type=script&lang=js&"
export * from "./CompanyHeader.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHeader.vue?vue&type=style&index=0&id=621a6d0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a6d0f",
  null
  
)

export default component.exports